import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'zh-Hant',
    fallbackLng: {
      'zh-Hant': ['zh-Hans', 'en'],
      'zh-Hans': ['zh-Hant', 'en'],
      default: ['en'],
    },
    supportedLngs: ['zh-Hant', 'zh-Hans', 'en'],
    ns: ['common', 'home', 'story'],
    defaultNS: 'common',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;